module.exports = __webpack_public_path__ + "static/dining3-23e4cd3e0d4253125c988945ec86a28e.jpg";